import 'react';
import {Box, Stack, Typography} from '@mui/material';
import {InputField} from '@/pages/components/common';
import {AuditProgramSectionVO} from '@/services/auditService/auditProgramService';
import type {TFormPage} from '@/pages/components/audit-program/t-section/constants';
import ProgramSectionHeader from '@/pages/components/audit-program/a-section/ProgramSectionHeader';

export interface TFormViewProps {
    header: AuditProgramSectionVO;
    page: TFormPage;
    refCode: string;
    values: Record<string, string>;
    onChange: (key: string, value: string) => void;
}

const fieldSx = {minWidth: 0, width: '100%', maxWidth: '100%'};

/** T04–T09 — CDD / risk / ID verification form pages. */
export default function TFormView({
    header,
    page,
    refCode,
    values,
    onChange,
}: TFormViewProps) {
    return (
        <Box sx={{p: 2}}>
            <ProgramSectionHeader
                header={header}
                variant="a12"
                refCode={refCode}
                values={values}
                onChange={onChange}
            />

            <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{textAlign: 'center', letterSpacing: 0.3, mb: 1.5, mt: 0.5}}
            >
                {page.title}
            </Typography>

            <Stack spacing={1.25} sx={{maxWidth: 820}}>
                {page.fields.map((f) => (
                    <Box key={f.id}>
                        <Typography variant="body2" sx={{mb: 0.5, fontWeight: 500}}>
                            {f.label}
                        </Typography>
                        <InputField
                            type="text"
                            fullWidth
                            compact
                            multiline
                            minRows={1}
                            sx={fieldSx}
                            value={values[f.id] ?? ''}
                            onChange={(e) => onChange(f.id, e.target.value)}
                        />
                    </Box>
                ))}
            </Stack>
        </Box>
    );
}
